import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { SemanticPathService } from '@spartacus/core';
import { CurrentProfileService } from '@user/feature';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

// Пускает только бригадиров
export const isForemanGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const currentProfileService = inject(CurrentProfileService);
  const semanticPathService = inject(SemanticPathService);

  const router = inject(Router);

  return currentProfileService.isForeman().pipe(
    take(1),
    map((isForeman) => {
      if (isForeman) {
        return true;
      }

      return router.parseUrl(semanticPathService.get('notFound'));
    }),
  );
};

// Не пускает бригадиров
export const isNotForemanGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const currentProfileService = inject(CurrentProfileService);
  const semanticPathService = inject(SemanticPathService);

  const router = inject(Router);

  return currentProfileService.isForeman().pipe(
    take(1),
    map((isForeman) => {
      if (!isForeman) {
        return true;
      }

      return router.parseUrl(semanticPathService.get('notFound'));
    }),
  );
};
